import React, { useState, useEffect } from "react";
import { Form } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import TextSpinner from "../Spinner/TextSpinner";
import useApiClient, { apiRoutes } from "../../../hooks/apiClient";
import { selectInputCacheActions } from "../../../redux/selectInputCache";

const SelectInputParteServicoFormik = ({ formik, field, disabled, tipoItem, tipoItemContexto, argumentos }) => {
  const stateKey = `${tipoItem}_${tipoItemContexto}`;
  const cachedItems = useSelector((state) => state.selectInputCache.cache[stateKey]);
  const dispatch = useDispatch();
  const [showErro, setshowErro] = useState(false);
  const [messageErro, setMessageErro] = useState("");

  const { request, data, errors, isLoading } = useApiClient();

  useEffect(() => {
    if (!cachedItems) {
      request(apiRoutes.fiscalizacao.parametrizacao.selectItems, {
        tipoItem,
        tipoItemContexto,
        argumentos,
      });
    }
  }, [request, tipoItem, tipoItemContexto, argumentos, cachedItems]);

  useEffect(() => {
    if (data) {
        const retorno = data.result.filter((item) => item.text === "SUCADI" || item.text === "COFIS" ||
                        item.text === "1ª URT" || item.text === "2ª URT" || item.text === "3ª URT" ||
                        item.text === "4ª URT" || item.text === "5ª URT" || item.text === "6ª URT" ||
                        item.text === "7ª URT" || item.text === "SUSCOMEX" || item.text === "SUFISE");

      dispatch(selectInputCacheActions.upsertItems({ tipoItem: stateKey, items: retorno }));
    }

    if (errors) {
      setMessageErro(errors.message);
      setshowErro(true);
    }
  }, [data, errors, dispatch, stateKey]);

  return (
    <>
      {showErro && (
        <>
          <br />
          <div className="alert alert-danger" role="alert">
            {messageErro}
          </div>
        </>
      )}
      {isLoading ? (
        <TextSpinner />
      ) : (
        !showErro && (
          <>
            <Form.Control
              as="select"
              id={field}
              name={field}
              disabled={disabled}
              value={formik.values[field]}
              onChange={formik.handleChange}
              isInvalid={formik.touched[field] && formik.errors[field]}
            >
              <option key="0" value="">
                Selecione
              </option>
              {(cachedItems || []).map((item) => (
                <option key={item.value} value={item.value}>
                  {item.text}
                </option>
              ))}
            </Form.Control>
            {formik.touched[field] && formik.errors[field] && (
              <Form.Control.Feedback type="invalid">{formik.errors[field]}</Form.Control.Feedback>
            )}
          </>
        )
      )}
    </>
  );
};

export default SelectInputParteServicoFormik;
